import { connect } from 'react-redux';

import { closeAlert } from 'actions/alert';

import Alert from './component';

const mapStateToProps = ({ alert }, { namespace }) => ({
	show: alert[namespace].show,
	text: alert[namespace].message,
	success: alert[namespace].success,
});

const mapDispatchToProps = (dispatch, { namespace }) => ({
	onCloseAlert: () => dispatch(closeAlert(namespace)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Alert);



// WEBPACK FOOTER //
// ./src/components/atoms/Alert/index.js